// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
// import { StoreProptypes } from "../../PropTypes/StoreProptypes";
// import { Button, Form } from "react-bootstrap";
// import { useEffect, useState } from "react";
// import WidgetCustomSizeControl from "../WidgetCustomSizeControl";


// interface PropTypes {
//     setChangeWidgetIconSize: Function, // function to flag widget icon size change
//     changeWidgetIconColor: string, // flag of widget icon size change
//     setIsChangeWidgetIconCustomSize: Function, // function to flag custom widget icon size change
//     setChangeWidgetCustomIconSize: Function, // function to flag custom widget icon size
//     isShowCustomWidgetIconSizeMobile: boolean, // flag to display custom widget icon size for mobile
//     setIsShowCustomWidgetIconSizeMobile: Function // function to flag custom widget icon size for mobile
// }

// // component to render widget icon size settings
// const WidgetIconSize = (props: PropTypes) => {

//     // PropTypes
//     const { setChangeWidgetIconSize, setIsChangeWidgetIconCustomSize, setChangeWidgetCustomIconSize, isShowCustomWidgetIconSizeMobile, setIsShowCustomWidgetIconSizeMobile } = props;

//     // Redux Data
//     const { currentWebsite, currentWebsitePlanStatus } = useSelector((store: StoreProptypes) => store);

//     // Functions
//     const { t } = useTranslation();

//     // State
//     const [widgetIconSize, setWidgetIconSize] = useState<number>(3);
//     const [isWidgetIconCustomSize, setIsWidgetIconCustomSize] = useState<boolean>(false);
//     const [widgetIconCustomSize, setWidgetIconCustomSize] = useState<number>(50);


//     // Set current widget icon type
//     useEffect(() => {
//         // check if current website data is available
//         if (currentWebsite) {
//             // check if widget icon size is set
//             if (currentWebsite.widget_icon_size) {
//                 setWidgetIconSize(currentWebsite.widget_icon_size);
//             } else {
//                 setWidgetIconSize(3);
//             }

//             // check if custom widget size flag is set
//             if (currentWebsite.is_widget_custom_size === 1) {
//                 setIsWidgetIconCustomSize(true);
//             } else {
//                 setIsWidgetIconCustomSize(false);
//             }

//             // check if custom widget icon size is set
//             if (currentWebsite.widget_icon_size_custom) {
//                 setWidgetIconCustomSize(currentWebsite.widget_icon_size_custom);
//             } else {
//                 setWidgetIconCustomSize(50);
//             }

//             // check if flag is set for mobile icon size
//             if (currentWebsite.is_mobile_icon === 1) {
//                 setIsShowCustomWidgetIconSizeMobile(true);
//             } else {
//                 setIsShowCustomWidgetIconSizeMobile(false);
//             }

//         }
//     }, [currentWebsite]);

    
//     useEffect(() => {
//         // check if widget icon size is available
//         if (widgetIconSize) {
//             setChangeWidgetIconSize(widgetIconSize);
//         } else {
//             setChangeWidgetIconSize(3);
//         }
//     }, [widgetIconSize]);

//     useEffect(() => {
//         // check if custom widget icon size flag is set
//         if (isWidgetIconCustomSize) {
//             setIsChangeWidgetIconCustomSize(true);
//         } else {
//             setIsChangeWidgetIconCustomSize(false);
//         }
//     }, [isWidgetIconCustomSize]);

//     useEffect(() => {
//         // check if custom widget icon size is available
//         if (widgetIconCustomSize) {
//             setChangeWidgetCustomIconSize(widgetIconCustomSize);
//         } else {
//             setChangeWidgetCustomIconSize(50);
//         }
//     }, [widgetIconCustomSize]);


//     return (
//         <>
//             {isWidgetIconCustomSize ? (
//                 <>

//                     <div className="aioa_dashboard-widget-custom-settings border-bottom">
//                         <Form.Check
//                             type="switch"
//                             className="aioa_dashboard-switch"
//                             id="desktop-widget-icon-size"
//                                   label={<span style={{ fontSize: "0.90rem" }}>
//                                                     {t('Enable custom icon size')}
//                                                 </span>}
//                             checked={isWidgetIconCustomSize}
//                             onChange={(e) => setIsWidgetIconCustomSize(!isWidgetIconCustomSize)}
//                         />
//                     </div>


//                     <WidgetCustomSizeControl isType={1} setSelectedWidgetIconCustomSize={setWidgetIconCustomSize} selectedWidgetIconCustomSize={widgetIconCustomSize} />


//                     <div className="aioa_dashboard-widget-custom-settings border-top">
//                         <Form.Check
//                             type="switch"
//                             className="aioa_dashboard-switch"
//                             id="is-custom-widget-icon-size"
//                              label={<span style={{ fontSize: "0.90rem" }}>
//                                                     {t('Use different icon size for mobile')}
//                                                 </span>}
//                             checked={isShowCustomWidgetIconSizeMobile}
//                             onChange={(e) => setIsShowCustomWidgetIconSizeMobile(!isShowCustomWidgetIconSizeMobile)}
//                         />
//                     </div>
//                 </>
//             ) : (
//                 <>
//                     <div className="aioa_dashboard-widget-settings-btns justify-content-between">
//                         <span><strong>{t("Select Widget Icon Size")}:- </strong></span>
//                             <div>
//                             <Button onClick={() => setWidgetIconSize(1)} className={`${widgetIconSize === 1 ? 'active' : ''} icon-font`} size="sm">{t('Extra Small')}</Button>
//                             <Button onClick={() => setWidgetIconSize(2)} className={`${widgetIconSize === 2 ? 'active' : ''} icon-font`} size="sm">{t('Small')}</Button>
//                             <Button onClick={() => setWidgetIconSize(3)} className={`${widgetIconSize === 3 ? 'active' : ''} icon-font`} size="sm">{t('Medium')}</Button>
//                             <Button onClick={() => setWidgetIconSize(4)} className={`${widgetIconSize === 4 ? 'active' : ''} icon-font`} size="sm">{t('Large')}</Button>
//                             <Button onClick={() => setWidgetIconSize(5)} className={`${widgetIconSize === 5 ? 'active' : ''} icon-font`} size="sm">{t('Extra Large')}</Button>
//                             </div>
//                             <hr />
//                     </div>

//                     <div className="aioa_dashboard-widget-custom-settings border-top">
//                         <Form.Check
//                             type="switch"
//                             className="aioa_dashboard-switch"
//                             id="custom-switch-size"
//                              label={<span style={{ fontSize: "0.90rem" }}>
//                                                     {t('Enable custom icon size')}
//                                                 </span>}
//                             checked={isWidgetIconCustomSize}
//                             onChange={(e) => setIsWidgetIconCustomSize(!isWidgetIconCustomSize)}
//                         />
//                         {!currentWebsitePlanStatus.isFreeWidget ?
//                         <>
//                         <div>
//                             <Form.Check
//                                 type="switch"
//                                 className="aioa_dashboard-switch"
//                                 id="custom-switch-mobile-icon"
//                                  label={<span style={{ fontSize: "0.90rem" }}>
//                                                     {t('Use different icon size for mobile')}
//                                                 </span>}
//                                 style={{ marginTop: 0 }}
//                                 checked={isShowCustomWidgetIconSizeMobile}
//                                 onChange={(e) => setIsShowCustomWidgetIconSizeMobile(!isShowCustomWidgetIconSizeMobile)}
//                             />
//                         </div>
//                         <hr /></>
//                             : <></>}
//                     </div>
                            


//                 </>
//             )}
//         </>
//     )
// }

// export default WidgetIconSize;

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import WidgetCustomSizeControl from "../WidgetCustomSizeControl";

interface PropTypes {
    setChangeWidgetIconSize: Function,
    changeWidgetIconColor: string,
    setIsChangeWidgetIconCustomSize: Function,
    setChangeWidgetCustomIconSize: Function,
    isShowCustomWidgetIconSizeMobile: boolean,
    setIsShowCustomWidgetIconSizeMobile: Function
}

// Size options with short labels
const SIZE_OPTIONS = [
    { id: 1, label: 'XS' },
    { id: 2, label: 'S' },
    { id: 3, label: 'M' },
    { id: 4, label: 'L' },
    { id: 5, label: 'XL' },
];

const WidgetIconSize = (props: PropTypes) => {

    const {
        setChangeWidgetIconSize,
        setIsChangeWidgetIconCustomSize,
        setChangeWidgetCustomIconSize,
        isShowCustomWidgetIconSizeMobile,
        setIsShowCustomWidgetIconSizeMobile
    } = props;

    const { currentWebsite, currentWebsitePlanStatus } = useSelector((store: StoreProptypes) => store);
    const { t } = useTranslation();

    const [widgetIconSize, setWidgetIconSize] = useState<number>(3);
    const [isWidgetIconCustomSize, setIsWidgetIconCustomSize] = useState<boolean>(false);
    const [widgetIconCustomSize, setWidgetIconCustomSize] = useState<number>(50);

    useEffect(() => {
        if (currentWebsite) {
            if (currentWebsite.widget_icon_size) {
                setWidgetIconSize(currentWebsite.widget_icon_size);
            } else {
                setWidgetIconSize(3);
            }

            if (currentWebsite.is_widget_custom_size === 1) {
                setIsWidgetIconCustomSize(true);
            } else {
                setIsWidgetIconCustomSize(false);
            }

            if (currentWebsite.widget_icon_size_custom) {
                setWidgetIconCustomSize(currentWebsite.widget_icon_size_custom);
            } else {
                setWidgetIconCustomSize(50);
            }

            if (currentWebsite.is_mobile_icon === 1) {
                setIsShowCustomWidgetIconSizeMobile(true);
            } else {
                setIsShowCustomWidgetIconSizeMobile(false);
            }
        }
    }, [currentWebsite]);

    useEffect(() => {
        setChangeWidgetIconSize(widgetIconSize || 3);
    }, [widgetIconSize]);

    useEffect(() => {
        setIsChangeWidgetIconCustomSize(isWidgetIconCustomSize || false);
    }, [isWidgetIconCustomSize]);

    useEffect(() => {
        setChangeWidgetCustomIconSize(widgetIconCustomSize || 50);
    }, [widgetIconCustomSize]);

    const handleSizeSelect = (sizeId: number) => {
        setWidgetIconSize(sizeId);
    };

    return (
        <div className="d-flex flex-column gap-3">
            {/* Size Buttons Row */}
            <div style={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "flex-start",
                gap: "16px"
            }}>
                {/* Left side - Size Buttons */}
                <div style={{ flex: 1 }}>
                    <label style={{ fontSize: "0.75rem", marginBottom: "6px", display: "block", color: "#666", fontWeight: "500" }}>
                        {t('Icon Size')}
                    </label>
                    <div style={{ 
                        display: "flex", 
                        gap: "6px", 
                        flexWrap: "wrap" 
                    }}>
                        {SIZE_OPTIONS.map((size) => (
                            <button
                                key={size.id}
                                onClick={() => handleSizeSelect(size.id)}
                                style={{
                                    padding: "4px 12px",
                                    fontSize: "0.75rem",
                                    borderRadius: "4px",
                                    border: widgetIconSize === size.id && !isWidgetIconCustomSize ? "1px solid #420083" : "1px solid #d1d5db",
                                    backgroundColor: widgetIconSize === size.id && !isWidgetIconCustomSize ? "#420083" : "#fff",
                                    color: widgetIconSize === size.id && !isWidgetIconCustomSize ? "#fff" : "#374151",
                                    cursor: "pointer",
                                    transition: "all 0.15s ease",
                                    fontWeight: "500",
                                    minWidth: "42px"
                                }}
                            >
                                {size.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Right side - Custom Size Control */}
                <div style={{ minWidth: "180px" }}>
                    <label style={{ fontSize: "0.75rem", marginBottom: "6px", display: "block", color: "#666", fontWeight: "500" }}>
                        {t('Custom Size')}
                    </label>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="custom-size-switch"
                        label={<span style={{ fontSize: "0.8rem" }}>{t('Enable')}</span>}
                        checked={isWidgetIconCustomSize}
                        onChange={(e) => setIsWidgetIconCustomSize(!isWidgetIconCustomSize)}
                        style={{ fontSize: "0.8rem", marginBottom: "8px" }}
                    />
                    {isWidgetIconCustomSize && (
                        <WidgetCustomSizeControl 
                            isType={1} 
                            setSelectedWidgetIconCustomSize={setWidgetIconCustomSize} 
                            selectedWidgetIconCustomSize={widgetIconCustomSize} 
                        />
                    )}
                </div>
            </div>

            {/* Mobile Size Toggle - Full Width */}
            {!currentWebsitePlanStatus?.isFreeWidget && (
                <div>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="mobile-icon-size-switch"
                        label={<span style={{ fontSize: "0.8rem" }}>
                            {t('Different for mobile')}
                        </span>}
                        checked={isShowCustomWidgetIconSizeMobile}
                        onChange={(e) => setIsShowCustomWidgetIconSizeMobile(!isShowCustomWidgetIconSizeMobile)}
                    />
                </div>
            )}
        </div>
    )
}

export default WidgetIconSize;